import { type ExtractionErrorType, ExtractionStatus } from "@inrev/common";
import { DateTime } from "luxon";

export type ExtractionStatusFields = {
	status: ExtractionStatus;
	errorType?: ExtractionErrorType;
	errorMessage?: string;
	extractionTriggeredAt?: string;
	extractionCompletedAt?: string;
};

export function mergeExtractionStatus(
	bondRequestExtraction: ExtractionStatusFields | undefined,
	contractExtraction: ExtractionStatusFields | undefined,
): ExtractionStatusFields | undefined {
	if (!bondRequestExtraction) return contractExtraction;
	if (!contractExtraction) return bondRequestExtraction;

	const bondPending = bondRequestExtraction.status === ExtractionStatus.Pending;
	const contractPending = contractExtraction.status === ExtractionStatus.Pending;
	if (bondPending !== contractPending) {
		return bondPending ? bondRequestExtraction : contractExtraction;
	}

	const bothCompleted =
		bondRequestExtraction.status === ExtractionStatus.Completed &&
		contractExtraction.status === ExtractionStatus.Completed;
	if (bothCompleted) {
		const bondCompletedAt = bondRequestExtraction.extractionCompletedAt
			? DateTime.fromISO(bondRequestExtraction.extractionCompletedAt)
			: undefined;
		const contractCompletedAt = contractExtraction.extractionCompletedAt
			? DateTime.fromISO(contractExtraction.extractionCompletedAt)
			: undefined;

		if (!contractCompletedAt) return bondRequestExtraction;
		if (!bondCompletedAt) return contractExtraction;

		return contractCompletedAt >= bondCompletedAt ? contractExtraction : bondRequestExtraction;
	}

	const bondTriggeredAt = bondRequestExtraction.extractionTriggeredAt
		? DateTime.fromISO(bondRequestExtraction.extractionTriggeredAt)
		: undefined;
	const contractTriggeredAt = contractExtraction.extractionTriggeredAt
		? DateTime.fromISO(contractExtraction.extractionTriggeredAt)
		: undefined;

	if (!contractTriggeredAt) return bondRequestExtraction;
	if (!bondTriggeredAt) return contractExtraction;

	return contractTriggeredAt >= bondTriggeredAt ? contractExtraction : bondRequestExtraction;
}
